// extracted by mini-css-extract-plugin
export var contactImage = "contactLenses-module--contactImage--e4vTJ";
export var contactImageWrapper = "contactLenses-module--contactImageWrapper--351dA";
export var contactLensesGrid = "contactLenses-module--contactLensesGrid--y+t+K";
export var header = "contactLenses-module--header--JoHxM";
export var paragraph = "contactLenses-module--paragraph--5zVyD";
export var paragraphWrapper = "contactLenses-module--paragraphWrapper--3QgEa";
export var wrapper = "contactLenses-module--wrapper--3MlfU";